import React from "react";

export default function BenefitItem({ title, info, status }) {
  return (
    <div className="flex justify-between items-start border-b border-slate-100 pb-4 last:border-0">
      <div>
        <h4 className="font-semibold text-slate-800 mb-1">{title}</h4>
        <p className="text-sm text-slate-600">{info}</p>
      </div>
      <span className="text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded-full">
        {status}
      </span>
    </div>
  );
}
